import extendNode from '../extendNode.mjs'
import Color from '../Color.mjs'
import useComponentNode from '../_COMPONENT/useComponentNode.jsx'
import IconAd from '../AD/icon-ad.svg?react'
import api from './apiArrd.mjs'
import meta from './metaArrd.mjs'
import Model from './ModelArrd.mjs'
import PropertiesPane from './PropertiesPaneArrd.jsx'
import FormChoose from './FormChooseArrd.jsx'
import TableChoose from './TableChooseArrd.jsx'

export default () => {
    const ComponentNode = useComponentNode()

    return extendNode(ComponentNode, {
        ...meta,
        api,
        FormChoose,
        TableChoose,
        Model,
        PropertiesPane,

        attrNodes: {
            top: ['ATTR_ARRD_RESUME', 'ATTR_ARRD_TITLE'],
        },

        getIcons(map, node) {
            return [
                <IconAd
                    key="type"
                    fill={'#000'}
                />
            ]
        },

        getStyle(map, node) {
            return {
                ...this._getStyle(map, node, {
                    borderColor: Color.LIGHT_ORANGE,
                    backgroundColor: Color.LIGHT_ORANGE,
                }),

                shape: 'HorizontalHexagon',
            }
        },

        async _atOwnerPush(map, node, event) {
            const d = await this._getPushData(map, node)
            event.detail.amArRds.push(d)
        },

        _getCategories(map, node) {
            return [
                'ARRD_DE',
            ]
        },
    })
}
